// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { FileText, ArrowRight, Eye, Calendar, Clock, AlertCircle } from "lucide-react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import PageLoader from "../../helpers/PageLoader";
// import PageHeader from "../ui/PageHeader";
// import { formatDateTime } from "../../helpers/formatDateTime";

// export default function MyReviews() {
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   const fetchMyReviews = useCallback(async () => {
//     setLoading(true);
//     try {
//       const url = SummaryApi.getMyKraReview?.url || "/api/hr/kra/reviews/my-reviews";
//       const res = await api.get(url);
//       if (res.data.success) {
//         setReviews(res.data.data || []);
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load appraisal reviews.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchMyReviews();
//   }, [fetchMyReviews]);

//   // Status Badge Colors
//   const getStatusBadge = (status) => {
//     switch (status) {
//       case "COMPLETED":
//         return "bg-green-50 text-green-700 border-green-200";
//       case "UNDER_REVIEW":
//         return "bg-blue-50 text-blue-700 border-blue-200";
//       case "DISPUTED":
//         return "bg-red-50 text-red-700 border-red-200";
//       default:
//         return "bg-amber-50 text-amber-700 border-amber-200";
//     }
//   };

//   if (loading) return <PageLoader />;

//   return (
//     <div className="p-2 space-y-6 animate-in fade-in duration-300">
//       <PageHeader
//         title="My KRA Performance Reviews"
//         description="Track and complete your active appraisals, self-assessments, and review cycle feedbacks."
//         isSticky={true}
//         topOffset="top-[51px]"
//       />

//       {reviews.length === 0 ? (
//         <div className="bg-white border rounded-xl p-12 text-center max-w-xl mx-auto space-y-4 shadow-sm">
//           <div className="w-14 h-14 bg-gray-50 border rounded-full flex items-center justify-center mx-auto text-primary">
//             <FileText className="w-6 h-6" />
//           </div>
//           <div className="space-y-1">
//             <h3 className="font-bold text-gray-900 text-sm">No Review Periods Found</h3>
//             <p className="text-xs text-gray-400">
//               You do not have any appraisal reviews initiated for this cycle yet. Please contact HR if you believe this is an error.
//             </p>
//           </div>
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
//           {reviews.map((review) => {
//             const currentStage = review.stages[review.currentStageIndex];
//             const isCompletedReview = review.status === "COMPLETED";

//             // ──── [திருத்தம் 3]: ஆப்ஜெக்ட் ஐடிகளை ஸ்ட்ரிங் ஆக மாற்றி ஒப்பிடுதல் ────
//             const evaluatorIdStr = currentStage?.evaluatorId?._id || currentStage?.evaluatorId;
//             const userIdStr = review.userId?._id || review.userId;
//             const isMyTurn = evaluatorIdStr && userIdStr && evaluatorIdStr.toString() === userIdStr.toString();

//             return (
//               <div 
//                 key={review._id} 
//                 className="bg-white border hover:border-primary rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-200 flex flex-col justify-between space-y-5"
//               >
//                 <div className="space-y-3.5">
//                   <div className="flex justify-between items-start gap-2">
//                     <div className="space-y-1">
//                       <span className="text-[10px] bg-slate-100 text-slate-700 border border-slate-200 font-bold px-2 py-0.5 rounded uppercase">
//                         FY {review.year}
//                       </span>
//                       <h4 className="font-bold text-gray-900 text-base leading-tight">
//                         {review.period} Appraisal
//                       </h4>
//                     </div>
//                     <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${getStatusBadge(review.status)}`}>
//                       {review.status?.replace("_", " ")}
//                     </span>
//                   </div>

//                   <div className="space-y-2 text-xs text-gray-500 border-t pt-3">
//                     <div className="flex items-center gap-2">
//                       <Calendar className="w-4 h-4 text-gray-400" />
//                       <span>{formatDateTime(review.startDate,false)} - {formatDateTime(review.endDate,false)}</span>
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Clock className="w-4 h-4 text-gray-400" />
//                       {/* ──── [திருத்தம் 2]: மதிப்பீடு முடிந்திருந்தால் "Completed" என்றும் இல்லையெனில் தற்போதைய ஸ்டேஜையும் காட்டுதல் ──── */}
//                       <span>
//                         Active Step:{" "}
//                         <strong className="text-gray-800">
//                           {isCompletedReview ? "Completed" : (currentStage?.stageName || "N/A")}
//                         </strong>
//                       </span>
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Calendar className="w-4 h-4 text-gray-400" />
//                       <span>{formatDateTime(review.startDate,false)} - {formatDateTime(review.endDate,false)}</span>
//                     </div>
//                   </div>

//                   {/* Mini Stepper view */}
//                   <div className="pt-2 space-y-1">
//                     <p className="text-[9px] text-gray-400 font-bold uppercase tracking-wider">Workflow Tracker</p>
//                     <div className="flex gap-1.5 items-center">
//                       {review.stages.map((stage, sIdx) => {
//                         // ──── [திருத்தம் 1]: ரிவ்யூ முடிந்திருந்தால் அனைத்து ஸ்டேஜும் பச்சை (green) நிறமாக மாறும் ────
//                         const isStageCompleted = isCompletedReview || sIdx < review.currentStageIndex;
//                         const isStageActive = !isCompletedReview && sIdx === review.currentStageIndex;

//                         return (
//                           <div 
//                             key={sIdx} 
//                             className={`h-1.5 rounded-full flex-1 transition-colors ${
//                               isStageCompleted ? "bg-green-500" : isStageActive ? "bg-primary animate-pulse" : "bg-gray-100"
//                             }`} 
//                             title={`${stage.stageName}: ${isStageCompleted ? "Completed" : isStageActive ? "Active" : "Locked"}`}
//                           />
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="pt-4 border-t flex items-center justify-between gap-4">
//                   {/* ரிவ்யூ முழுமையாக முடிந்திருந்தால் Action Required காட்டாது */}
//                   {isMyTurn && !isCompletedReview ? (
//                     <div className="flex items-center gap-1.5 text-red-600 font-bold text-[11px] uppercase">
//                       <AlertCircle className="w-4 h-4 shrink-0" />
//                       <span>Action Required</span>
//                     </div>
//                   ) : (
//                     <div className="text-[10px] text-gray-400 font-bold uppercase">
//                       {isCompletedReview ? "Locked & Saved" : "Awaiting Evaluator"}
//                     </div>
//                   )}

//                   <button
//                     onClick={() => navigate(`reviews/evaluation/${review._id}`)}
//                     className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-bold text-xs uppercase transition-all ${
//                       isMyTurn && !isCompletedReview
//                         ? "bg-primary text-white hover:bg-secondary"
//                         : "bg-gray-50 border border-gray-200 text-gray-600 hover:bg-gray-100"
//                     }`}
//                   >
//                     {isMyTurn && !isCompletedReview ? (
//                       <>
//                         <span>Start Appraisal</span>
//                         <ArrowRight className="w-3.5 h-3.5" />
//                       </>
//                     ) : (
//                       <>
//                         <span>View Details</span>
//                         <Eye className="w-3.5 h-3.5" />
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FileText, ArrowRight, Eye, Calendar, Clock, AlertCircle, Star, Award, ChevronDown } from "lucide-react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import PageLoader from "../../helpers/PageLoader";
import PageHeader from "../ui/PageHeader";
import { formatDateTime } from "../../helpers/formatDateTime";

// Helper function to resolve KRA achievement rating based on image grading scale
const getAchievementRating = (percentage) => {
  if (percentage === null || percentage === undefined || isNaN(percentage)) return "N/A";
  if (percentage >= 110) return "Outstanding";
  if (percentage >= 100) return "Exceeds Expectations";
  if (percentage >= 90) return "Meets Expectations";
  if (percentage >= 75) return "Needs Improvement";
  return "Unsatisfactory";
};

// Helper function to return beautiful styling badge classes
const getRatingBadgeClass = (rating) => {
  switch (rating) {
    case "Outstanding": return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case "Exceeds Expectations": return "bg-teal-50 text-teal-700 border-teal-200";
    case "Meets Expectations": return "bg-blue-50 text-blue-700 border-blue-200";
    case "Needs Improvement": return "bg-amber-50 text-amber-700 border-amber-200";
    case "Unsatisfactory": return "bg-red-50 text-red-700 border-red-200";
    default: return "bg-gray-50 text-gray-700 border-gray-200";
  }
};

export default function MyReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(""); 
  const [expandedYears, setExpandedYears] = useState({}); 
  const navigate = useNavigate();

  const fetchMyReviews = useCallback(async () => {
    setLoading(true);
    try {
      let url = SummaryApi.getMyKraReview?.url || "/api/hr/kra/reviews/my-reviews";
      if (selectedYear) {
        url += `?year=${selectedYear}`;
      }
      
      const res = await api.get(url);
      if (res.data.success) {
        setReviews(res.data.data || []);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load appraisal reviews.");
    } finally {
      setLoading(false);
    }
  }, [selectedYear]);

  useEffect(() => {
    fetchMyReviews();
  }, [fetchMyReviews]);

  // Groups reviews year-wise dynamically
  const groupedReviews = useMemo(() => {
    const groups = {};
    reviews.forEach(review => {
      const year = review.year || new Date().getFullYear();
      if (!groups[year]) {
        groups[year] = [];
      }
      groups[year].push(review);
    });
    return groups;
  }, [reviews]);

  // Dynamic list of years sorted in descending order (recent year first)
  const sortedYears = useMemo(() => {
    return Object.keys(groupedReviews).sort((a, b) => b - a);
  }, [groupedReviews]);

  // Generates a continuous list of years starting from 2025 up to the current calendar year (e.g. 2030)
  const availableFilterYears = useMemo(() => {
    const years = [];
    const startYear = 2025; // System launch year
    const currentYear = new Date().getFullYear(); // Automatically gets current year (e.g. 2030)

    // Generates years from currentYear down to 2025 (e.g. 2030, 2029, 2028..., 2025)
    for (let y = currentYear; y >= startYear; y--) {
      years.push(y);
    }

    // Safety fallback: Include any historic reviews from database if they are older than 2025
    reviews.forEach(r => {
      if (r.year && r.year < startYear && !years.includes(r.year)) {
        years.push(r.year);
      }
    });

    return years.sort((a, b) => b - a);
  }, [reviews]);

  // Expands the most recent year automatically on load
  useEffect(() => {
    if (sortedYears.length > 0) {
      setExpandedYears({ [sortedYears[0]]: true });
    }
  }, [sortedYears]);

  const toggleYearExpand = (year) => {
    setExpandedYears(prev => ({
      ...prev,
      [year]: !prev[year]
    }));
  };

  // Status Badge Colors
  const getStatusBadge = (status) => {
    switch (status) {
      case "COMPLETED":
        return "bg-green-50 text-green-700 border-green-200";
      case "UNDER_REVIEW":
        return "bg-blue-50 text-blue-700 border-blue-200";
      case "DISPUTED":
        return "bg-red-50 text-red-700 border-red-200";
      default:
        return "bg-amber-50 text-amber-700 border-amber-200";
    }
  };

  if (loading) return <PageLoader />;

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <PageHeader
        title="My KRA Performance Reviews"
        description="Track and complete your active appraisals, self-assessments, and review cycle feedbacks."
        isSticky={true}
        topOffset="top-[51px]"
      />

      {/* Filter Control Board */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
        <div className="text-left">
          <span className="text-[10px] font-bold uppercase tracking-wider text-primary">Appraisal Cycles</span>
          <h2 className="text-sm sm:text-base font-bold text-gray-900 leading-tight">My Appraisal Sheets</h2>
        </div>
        
        {/* Dynamic Year Dropdown Selector */}
        <div className="flex items-center gap-2 text-xs">
          <span className="font-bold text-gray-500">Filter Year:</span>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="border rounded-lg px-3 py-1.5 font-semibold bg-slate-50 outline-none text-xs focus:ring-1 focus:ring-red-200 cursor-pointer"
          >
            <option value="">All Years</option>
            {availableFilterYears.map((y) => (
              <option key={y} value={y}>
                FY {y}
              </option>
            ))}
          </select>
        </div>
      </div>

      {reviews.length === 0 ? (
        <div className="bg-white border rounded-xl p-12 text-center max-w-xl mx-auto space-y-4 shadow-sm">
          <div className="w-14 h-14 bg-gray-50 border rounded-full flex items-center justify-center mx-auto text-primary">
            <FileText className="w-6 h-6 text-primary" />
          </div>
          <div className="space-y-1">
            <h3 className="font-bold text-gray-900 text-sm">No Review Periods Found</h3>
            <p className="text-xs text-gray-400">
              You do not have any appraisal reviews initiated for this cycle yet. Please contact HR if you believe this is an error.
            </p>
          </div>
        </div>
      ) : (
        <div className="space-y-6">
          {sortedYears.map((year) => {
            const isExpanded = expandedYears[year];
            const yearReviews = groupedReviews[year] || [];

            return (
              <div key={year} className="border rounded-xl bg-white overflow-hidden shadow-sm">
                <button
                  onClick={() => toggleYearExpand(year)}
                  className="w-full flex items-center justify-between p-4 bg-slate-50 hover:bg-slate-100 transition-colors border-b text-left"
                >
                  <span className="font-bold text-slate-800 text-sm sm:text-base">
                    FY {year} Appraisal Cycle ({yearReviews.length} Reviews)
                  </span>
                  <ChevronDown className={`w-5 h-5 text-slate-500 transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`} />
                </button>

                {isExpanded && (
                  <div className="p-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 animate-in fade-in duration-300">
                    {yearReviews.map((review) => {
                      const currentStage = review.stages[review.currentStageIndex];
                      const isCompletedReview = review.status === "COMPLETED";

                      const evaluatorIdStr = currentStage?.evaluatorId?._id || currentStage?.evaluatorId;
                      const userIdStr = review.userId?._id || review.userId;
                      const isMyTurn = evaluatorIdStr && userIdStr && evaluatorIdStr.toString() === userIdStr.toString();

                      const activeWeightageSum = review.kras?.reduce((sum, k) => sum + Number(k.weightage || 0), 0) || 100;
                      
                      const selfOverallScore = review.kras?.reduce((sum, k) => sum + Number(k.weightedScore || 0), 0) || 0;
                      
                      const hasSelfAppraisalSubmitted = review.kras?.some(k => k.actualValue !== "" && k.actualValue !== undefined) || review.status === "COMPLETED";

                      const selfAchievementPct = hasSelfAppraisalSubmitted 
                        ? ((selfOverallScore / activeWeightageSum) * 100).toFixed(2) 
                        : "0.00";

                      return (
                        <div 
                          key={review._id} 
                          className="bg-white border hover:border-primary rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-200 flex flex-col justify-between space-y-5"
                        >
                          <div className="space-y-3.5">
                            <div className="flex justify-between items-start gap-2">
                              <div className="space-y-1 text-left">
                                <span className="text-[10px] bg-slate-100 text-slate-700 border border-slate-200 font-bold px-2 py-0.5 rounded uppercase">
                                  FY {review.year}
                                </span>
                                <h4 className="font-bold text-gray-900 text-base leading-tight">
                                  {review.period} Appraisal
                                </h4>
                              </div>
                              
                              <div className="flex flex-col items-end gap-1.5 shrink-0">
                                <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${getStatusBadge(review.status)}`}>
                                  {review.status?.replace("_", " ")}
                                </span>
                                {hasSelfAppraisalSubmitted && (
                                  <span className="flex items-center gap-1 bg-amber-50 text-amber-700 border border-amber-200 font-bold px-2 py-0.5 rounded-lg text-[10px]">
                                    <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
                                    Self Score: {selfOverallScore.toFixed(2)} / {activeWeightageSum}
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* KRA Meta Details Block */}
                            <div className="space-y-2 text-xs text-gray-500 border-t pt-3 text-left">
                              <div className="flex items-center gap-2">
                                <Calendar className="w-4 h-4 text-gray-400 font-bold" />
                                <span>{formatDateTime(review.startDate,false)} - {formatDateTime(review.endDate,false)}</span>
                              </div>
                              <div className="flex items-center gap-2">
                                <Clock className="w-4 h-4 text-gray-400 font-bold" />
                                <span>
                                  Active Step:{" "}
                                  <strong className="text-gray-800">
                                    {isCompletedReview ? "Completed" : (currentStage?.stageName || "N/A")}
                                  </strong>
                                </span>
                              </div>
                            </div>

                            {/* Dynamic Stats Grid Panel */}
                            <div className="grid grid-cols-2 gap-3 py-2.5 border-y border-dashed border-gray-100 text-[11px] text-gray-500 bg-gray-50/50 px-3 rounded-lg font-medium text-left">
                              <div>
                                <span className="text-[9px] text-gray-400 font-bold uppercase block">KRA Count</span>
                                <span className="font-bold text-gray-700">{review.kras?.length || 0} Areas</span>
                              </div>
                              <div>
                                <span className="text-[9px] text-gray-400 font-bold uppercase block">Active Weight</span>
                                <span className="font-bold text-gray-700">{activeWeightageSum}%</span>
                              </div>
                            </div>

                            {/* Live Self Achievement % and Grade Badge Row */}
                            {hasSelfAppraisalSubmitted && (
                              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 bg-slate-50 p-2.5 rounded-lg border text-left text-xs">
                                <div className="flex items-center gap-2">
                                  <Award className="w-4 h-4 text-emerald-500 shrink-0" />
                                  <span>
                                    Self Achievement: <strong className="text-emerald-600 font-extrabold">{selfAchievementPct}%</strong>
                                  </span>
                                </div>
                                <span className={`text-[9px] font-bold px-2 py-0.5 rounded border uppercase tracking-wider text-center ${getRatingBadgeClass(getAchievementRating(parseFloat(selfAchievementPct)))}`}>
                                  {getAchievementRating(parseFloat(selfAchievementPct))}
                                </span>
                              </div>
                            )}

                            {/* Workflow Progress Stepper */}
                            <div className="pt-1 space-y-1">
                              <p className="text-[9px] text-gray-400 font-bold uppercase tracking-wider text-left">Workflow Progress</p>
                              <div className="flex gap-1.5 items-center">
                                {review.stages.map((stage, sIdx) => {
                                  const isStageCompleted = isCompletedReview || sIdx < review.currentStageIndex;
                                  const isStageActive = !isCompletedReview && sIdx === review.currentStageIndex;

                                  return (
                                    <div 
                                      key={sIdx} 
                                      className={`h-1.5 rounded-full flex-1 transition-colors ${
                                        isStageCompleted ? "bg-green-500" : isStageActive ? "bg-primary animate-pulse" : "bg-gray-100"
                                      }`} 
                                      title={`${stage.stageName}: ${isStageCompleted ? "Completed" : isStageActive ? "Active" : "Locked"}`}
                                    />
                                  );
                                })}
                              </div>
                            </div>
                          </div>

                          <div className="pt-4 border-t flex items-center justify-between gap-4">
                            {isMyTurn && !isCompletedReview ? (
                              <div className="flex items-center gap-1.5 text-red-600 font-bold text-[11px] uppercase">
                                <AlertCircle className="w-4 h-4 shrink-0" />
                                <span>Action Required</span>
                              </div>
                            ) : (
                              <div className="text-[10px] text-gray-400 font-bold uppercase">
                                {isCompletedReview ? "Locked & Saved" : "Awaiting Evaluator"}
                              </div>
                            )}

                            <button
                              onClick={() => navigate(`reviews/evaluation/${review._id}`)}
                              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-bold text-xs uppercase transition-all ${
                                isMyTurn && !isCompletedReview
                                  ? "bg-primary text-white hover:bg-secondary"
                                  : "bg-gray-50 border border-gray-200 text-gray-600 hover:bg-gray-100"
                              }`}
                            >
                              {isMyTurn && !isCompletedReview ? (
                                <>
                                  <span>Start Appraisal</span>
                                  <ArrowRight className="w-3.5 h-3.5" />
                                </>
                              ) : (
                                <>
                                  <span>View Details</span>
                                  <Eye className="w-3.5 h-3.5 animate-pulse" />
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}